// removed by extract-text-webpack-plugin
module.exports = {"myMenu":"_2Jcm3o8vVW82WR9etIMubs","active":"_2sGyAm3co-e63koqPSSEOn","avar":"_26gm2yDCnlmDhDhEiW9yPl","blink":"_2EY28aQS2rDgbMeaB1tPoE"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/Menu/style.css
// module id = 350
// module chunks = 0